import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { DashboardStatsResponse } from "../../../shared/response/proyectos/DashboardStatsResponse";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** KPIs del dashboard de proyectos (`ProyectosPlataformaService.GetDashboardStats`, gRPC). */
export class ProyectosDashboardService {
  static readonly instance = new ProyectosDashboardService();
  private constructor() {}

  /**
   * Proyectos activos, hectáreas, CAPEX/OPEX presupuestado y ejecutado, top 5 de desviación, totales de
   * macro-proyectos, núcleos y beneficiarios, proyectos por estado y pendientes de aprobación.
   */
  async getStats(): Promise<DashboardStatsResponse> {
    const s = await grpcCall(() => grpcClient(ProyectosPlataformaService).getDashboardStats({}));
    return {
      proyectosActivos: s.proyectosActivos,
      nuevosEsteMes: s.nuevosEsteMes,
      totalHa: s.totalHa,
      tecnicosActivos: s.tecnicosActivos,
      snapshotAño: s.snapshotAnio ?? null,
      snapshotIpc: s.snapshotIpc ?? null,
      capexPresupuestado: Number(s.capexPresupuestado),
      capexEjecutado: Number(s.capexEjecutado),
      opexPresupuestado: Number(s.opexPresupuestado),
      opexEjecutado: Number(s.opexEjecutado),
      haPorCultivo: s.haPorCultivo.map((h) => ({ cultivoNombre: h.cultivoNombre, totalHa: h.totalHa })),
      mayorDesviacion: s.mayorDesviacion.map((d) => ({
        itemNombre: d.itemNombre,
        cultivoNombre: d.cultivoNombre,
        proyectosAfectados: d.proyectosAfectados,
        desviacion: d.desviacion,
      })),
      totalMacroProyectos: s.totalMacroProyectos,
      macroProyectosActivos: s.macroProyectosActivos,
      totalNucleos: s.totalNucleos,
      totalBeneficiarios: s.totalBeneficiarios,
      proyectosPorEstado: s.proyectosPorEstado.map((e) => ({ estado: e.estado, cantidad: e.cantidad })),
      proyectosPendientesAprobacion: s.proyectosPendientesAprobacion,
      proyectosPendientesMasDe5Dias: s.proyectosPendientesMasDe5Dias,
    };
  }
}
